var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 47.3333C11.1133 47.3333 0.666992 36.887 0.666992 24C0.666992 11.113 11.1133 0.666664 24.0003 0.666664C36.8873 0.666664 47.3337 11.113 47.3337 24C47.3337 36.887 36.8873 47.3333 24.0003 47.3333ZM24.0003 42.6667C28.951 42.6667 33.699 40.7 37.1997 37.1993C40.7003 33.6986 42.667 28.9507 42.667 24C42.667 19.0493 40.7003 14.3014 37.1997 10.8007C33.699 7.29999 28.951 5.33333 24.0003 5.33333C19.0496 5.33333 14.3017 7.29999 10.801 10.8007C7.30032 14.3014 5.33366 19.0493 5.33366 24C5.33366 28.9507 7.30032 33.6986 10.801 37.1993C14.3017 40.7 19.0496 42.6667 24.0003 42.6667ZM21.667 31H26.3337V35.6667H21.667V31ZM21.667 12.3333H26.3337V26.3333H21.667V12.3333Z",
    fill: "#FF0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.5facdf49b65a7ae7bf7bb2b40928379e.svg";
export { ForwardRef as ReactComponent };